module.exports = __webpack_public_path__ + "static/img/2.d60de77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer5/en/btn1/2.jpg
// module id = p7Ai
// module chunks = 0